import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Materials } from '../types';

export default class MaterialsState extends BaseState {
  materials_loading = false;
  nested_materials: Materials.Material[] = [];
  material_url: Materials.MarketingMaterialUrl | null = null;
  material: Materials.Material | null = null;

  downloading = false;
  downloading_failed = false;
  downloaded_bytes = 0;
  download_length = 0;
  downloaded_file_name: string | null = null;
  downloaded_url: string | null = null;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
